<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">库存管理&nbsp;/&nbsp;</span>
      </div>
      <div>库存盘点</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div>
              <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月" @change="totalCounts" :clearable="false"></el-date-picker>
              <el-select v-model="query.checkType" placeholder="出库类型" filterable @change="selectChange" class="ml10">
                <el-option
                  v-for="item in option1"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="query.checkStatus" placeholder="全部状态" filterable @change="selectChange" class="ml10">
                <el-option
                  v-for="item in option2"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="addList">新增盘点</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="name" label="盘点名称" width="200px"></el-table-column>
              <el-table-column prop="checkType" label="盘点类型" width="auto">
                <template slot-scope="scope">{{scope.row.checkTypeCn}}盘点</template>
              </el-table-column>
              <el-table-column prop="beginTime" label="盘点开始时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.beginTime) }}</template>
              </el-table-column>
              <el-table-column prop="endTime" label="盘点结束时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.endTime) }}</template>
              </el-table-column>
              <el-table-column prop="createName" width="auto" label="制单人员"></el-table-column>
              <el-table-column prop="checkStatusCn" label="状态" width="auto"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="leaveRequest(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange" @refreshNext="refreshNextEdit"></edit-set>
    <nextEdit-set ref="nextEditSetForm" @change="handleChange"></nextEdit-set>
    <add-set ref="addSetForm" @change="handleChange"></add-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import nextEditSet from "./nextEdit";
import addSet from "./add";
export default {
  data() {
    return {
      url: this.$url.checkBillInfo.list,
      query: {
        dataMonth: "",
        checkType: "",
        checkStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      option1: [
        {
          text: "全部类型",
          value: ""
        },
        {
          text: "全部盘点",
          value: "whole"
        },
        {
          text: "部分盘点",
          value: "part"
        },
      ],
      option2: [{
          text: "全部状态",
          value: ""
        },
        {
          text: "待审核",
          value: "wait"
        },
        {
          text: "盘点中",
          value: "check"
        },
        {
          text: "处理中",
          value: "processing"
        },
        {
          text: "通过",
          value: "pass"
        },
        {
          text: "拒绝",
          value: "refuse"
        },
        {
          text: "作废",
          value: "cancel"
        },
        {
          text: "撤销",
          value: "recall"
        }
      ],
      list: []
    };
  },
  mixins: [minxin],
  components: { nextEditSet, editSet, addSet},
  computed: {},

  created() {
    this.query.dataMonth = this.formatMonth(new Date())
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/dataList/inventory");
    },
    leaveRequest (row) {

      if (row.checkStatus == 'check') {
          this.$refs["nextEditSetForm"].$emit("set", row);
        } else {
          this.$refs["editSetForm"].$emit("set", row);
        }
    },
    addList () {
      this.$refs["addSetForm"].$emit("set", true);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    refreshNextEdit(value) {
      this.$refs["nextEditSetForm"].$emit("set", { id: value });
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.checkBillInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

